<!-- Gateway Lamps Search           :ok-title="$t('gateway_lamps_insert_modal.send')"
                                    @ok="close"-->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"      
      ref="modal"
      id="modal-gateway-lamps-search"
      :title="$t('gateway_lamps_insert_modal.search_title', { id: this.gatewayId})"
      size="md"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="this.cu != null" class="live-stats-content">
       
        <b-row v-if="this.searchingOn" class="d-flex justify-content-center">
          <div role="status" aria-live="polite">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
            <span class="sr-only">{{ $t('search_in_progress') }}</span>
          </div>
          
        </b-row>

        <b-row class="d-flex justify-content-center my-3">
            <h4>{{ $t('gateway_lamps_insert_modal.found_summary', {
              found: (this.dataPolling.message_attribute.ble_found || 0),
              total: (this.dataPolling.message_attribute.ble_present || 0)
            }) }} </h4>
        </b-row>

        <hr class="my-3">

        <b-row>
          <b-col>
            <b-list-group>
              <b-list-group-item class="d-flex justify-content-between align-items-center" variant="success">
                <strong>{{ $t('gateway_lamps_insert_modal.lamps_direct') }}</strong>
                <h4><b-badge variant="success" pill>{{ this.dataPolling.message_attribute.ble_found_direct || 0 }}</b-badge></h4>
              </b-list-group-item>

              <b-list-group-item class="d-flex justify-content-between align-items-center" variant="primary">
                <strong>{{ $t('gateway_lamps_insert_modal.lamps_indirect') }}</strong>
                <h4><b-badge variant="primary" pill>{{ this.dataPolling.message_attribute.ble_found_indirect || 0 }}</b-badge></h4>
              </b-list-group-item>

              <b-list-group-item class="d-flex justify-content-between align-items-center" variant="danger">
                <strong>{{ $t('gateway_lamps_insert_modal.lamps_error') }}</strong>
                <h4><b-badge variant="danger" pill>{{ this.dataPolling.message_attribute.ble_error || 0 }}</b-badge></h4>
              </b-list-group-item>

            </b-list-group>
          </b-col>
        </b-row>
       
        <!-- <b-button 
            @click="stopSearchAndHideModal" 
            variant="warning" 
            class="mt-3 w-100"
            :disabled="!searching"
        >
            Stop Search
        </b-button> -->
      </div>
    </b-modal> 
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  components: {
    VueSlider
  },
  name: "GatewayLampsSearch",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    dataPolling: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    searchingOn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      
    };

    
  },

  computed: {
    gatewayId() {
      if (this.cu != null) {
        return this.cu.cu_id;
      } else {
        return null;
      }
    }
  },

  watch: {

  },

  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },

    // stopSearchAndHideModal() {

    // },  

  }
}

</script>

<style>
 
</style>